import { fetchConfigs } from './fetchConfigs'
import { COLORS } from '../constants'

type Thresholds = {
  LOWER_PERCENT: number
  UPPER_PERCENT: number
  HIGH_PERCENT: number
  MAX_PERCENT: number
}

type PercentageBarConfig = {
  message: string
  color: string
}

// Cache to store the thresholds and the path from which they were fetched
let cachedThresholds: Thresholds | null = null
let cachedPathname: string = ''

export const getCachedThresholds = (): Thresholds | null => {
  return cachedThresholds
}

export const getPercentageBarConfig = async (
  percentage: number,
  pathname: string
): Promise<PercentageBarConfig> => {
  // Check if the thresholds are cached and if the pathname has changed
  if (!cachedThresholds || cachedPathname !== pathname) {
    try {
      cachedThresholds = await fetchConfigs()
      cachedPathname = pathname // Update cached pathname
    } catch (error) {
      console.error('Error fetching thresholds:', error)
      return {
        message: 'Unable to fetch thresholds',
        color: COLORS.secondary
      }
    }
  }

  const { LOWER_PERCENT, UPPER_PERCENT, HIGH_PERCENT, MAX_PERCENT } =
    cachedThresholds

  if (percentage > MAX_PERCENT) {
    return {
      message: 'Please remove to achieve a Half or Full Truckload',
      color: 'red'
    }
  }

  if (percentage >= HIGH_PERCENT && percentage <= MAX_PERCENT) {
    return { message: 'Full Truckload', color: 'green' }
  }

  if (percentage >= LOWER_PERCENT && percentage <= UPPER_PERCENT) {
    return { message: 'Half Truckload', color: 'green' }
  }

  return {
    message: 'Please add/remove to achieve a Half or Full Truckload',
    color: 'yellow'
  }
}
